export default "__VITE_ASSET__BAQ_ceT$__"